module.exports = __webpack_public_path__ + "media/images/pages/img_living_02-997c722caf51042990bf1a7b4d1ffd0f.jpg";